var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 15,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7031 27H15.7207V25.1104L18.9463 21.8496C19.5967 21.1816 20.1182 20.625 20.5107 20.1797C20.9092 19.7285 21.1963 19.3184 21.3721 18.9492C21.5537 18.5801 21.6445 18.1846 21.6445 17.7627C21.6445 17.2529 21.501 16.8721 21.2139 16.6201C20.9326 16.3623 20.5547 16.2334 20.0801 16.2334C19.582 16.2334 19.0986 16.3477 18.6299 16.5762C18.1611 16.8047 17.6719 17.1299 17.1621 17.5518L15.6855 15.8027C16.0547 15.4863 16.4443 15.1875 16.8545 14.9062C17.2705 14.625 17.751 14.3994 18.2959 14.2295C18.8467 14.0537 19.5059 13.9658 20.2734 13.9658C21.1172 13.9658 21.8408 14.1182 22.4443 14.4229C23.0537 14.7275 23.5225 15.1436 23.8506 15.6709C24.1787 16.1924 24.3428 16.7842 24.3428 17.4463C24.3428 18.1553 24.2021 18.8027 23.9209 19.3887C23.6396 19.9746 23.2295 20.5547 22.6904 21.1289C22.1572 21.7031 21.5127 22.3389 20.7568 23.0361L19.1045 24.5918V24.7148H24.7031V27Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.296765f38b882b3ccb9aa395fafc3add.svg";
export { ForwardRef as ReactComponent };